export class BinHashUtils {
    static getHash(buffer, start, len, magic = 9191891) {
        var i;
        var rst = 0;
        for (i = 0; i < len; i++) {
            rst = (rst * 2 + buffer[start + i]) % magic;
        }
        return rst;
    }
    static isSame(buffer1, start1, len1, buffer2, start2, len2) {
        if (len1 != len2)
            return false;
        var i, len;
        len = len1;
        for (i = 0; i < len; i++) {
            if (buffer1[start1 + i] != buffer2[start2 + i])
                return false;
        }
        return true;
    }
}
